// API base URL - uses relative path so requests go through same-origin proxy
// This avoids cross-origin issues when deployed on custom domains
// The platform proxies /api/* to the backend on both preview and production domains
const BACKEND_URL = "";

export default BACKEND_URL;
